import { combineReducers } from 'redux';
import {
  OPEN_PLATFORM_APP_LEARN_MORE_SET_APP,
  OPEN_PLATFORM_APP_LEARN_MORE_RESET,
} from 'actions/openPlatform/appLearnMore/constants';

import createReducer from 'utils/createReducer';

const app = createReducer(
  {
    description: '',
    logo: '',
    oauth_application_images: [],
    phone: '',
    price: '',
    short_description: '',
    support_email: '',
    title: '',
    website: '',
  },
  {
    [OPEN_PLATFORM_APP_LEARN_MORE_SET_APP]: (draft, { payload }) => payload.app,
    [OPEN_PLATFORM_APP_LEARN_MORE_RESET]: () => ({
      description: '',
      logo: '',
      oauth_application_images: [],
      phone: '',
      price: '',
      short_description: '',
      support_email: '',
      title: '',
      website: '',
    }),
  }
);

export default combineReducers({
  app,
});
